import { gql } from 'apollo-angular';

export const get_permissions_for_resource = gql`
  query getUserPermissions($resourceType: ResourceType!, $resourceId: String) {
    me {
      permissionsForResource(
        resourceType: $resourceType
        resourceId: $resourceId
      ) {
        _edit
        _read
        _delete
      }
    }
  }
`;

export const get_permissions_for_resource_batch = gql`
  query getUserPermissionsBatch($requestedPerms: [PermsRequest]!) {
    me {
      permissionsForResourceBatch(
        requestedPerms: $requestedPerms
      ) {
        _edit
        _read
        _delete
      }
    }
  }
`;

export default {
  get_permissions_for_resource,
  get_permissions_for_resource_batch
};
